import { MemoizedSelector, createFeatureSelector, createSelector } from '@ngrx/store';
import { SharedFeatureState } from '../states';

export const selectSharedFeature: MemoizedSelector<object, SharedFeatureState> = createFeatureSelector<SharedFeatureState>('sharedFeature');
